<template>
  <div class="block">
    <div class="line">
      <div class="line-name">企业ID</div>
      <div class="line-value">
        {{ followDetail.id }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">企业名称</div>
      <div class="line-value">
        {{ followDetail.name }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">CorpID</div>
      <div class="line-value ellipsis">
        {{ followDetail.corpid }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">行业</div>
      <div class="line-value">
        {{ followDetail.industry }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">管理员姓名</div>
      <div class="line-value">
        {{ followDetail.main_user_name }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">开通时间</div>
      <div class="line-value">
        {{ followDetail.create_time }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">使用版本</div>
      <div class="line-value">
        {{ versions[versions_name] }}
      </div>
      <!-- <div class="line-value"
        v-if="followDetail.is_charge_user === 0"
      >
        免费版
      </div>
      <div class="line-value"
        v-if="followDetail.is_charge_user === 1"
      >
        付费版
      </div>
      <div class="line-value"
        v-if="followDetail.is_charge_user === 2"
      >
        试用版
      </div> -->
    </div>
    <div class="line">
      <div class="line-name">企业人数</div>
      <div class="line-value">
        {{ followDetail.user_num }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">到期时间</div>
      <div class="line-value">
        {{ followDetail.service_expire_time }}
        <Button
          size="small"
          class="expiretime-btn"
          v-if="
            this.user.isMain === 1 &&
            this.user.sysrole === 1 &&
            followDetail.service_expire_time
          "
          @click="expiretime"
        >
          修改
        </Button>
      </div>
    </div>
    <div class="line">
      <div class="line-name">联系人</div>
      <div class="line-value">
        {{ followDetail.link_person }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">联系电话</div>
      <div class="line-value">
        {{ followDetail.link_msisdn }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">专属客服</div>
      <div class="line-value">
        {{ followDetail.custom_service_name }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">模板数</div>
      <div class="line-value">
        {{ followDetail.ordertype_tmpl_limit_num }}
        <Button
          size="small"
          class="expiretime-btn"
          v-if="user.isMain == 1 && user.sysrole == 1"
          @click="recharge(['模板数更改', 'templateModal'])"
        >
          修改
        </Button>
      </div>
    </div>
    <div class="line">
      <div class="line-name">已使用模板数</div>
      <div class="line-value">{{ followDetail.useTmplNum }} 个</div>
    </div>
    <div class="line">
      <div class="line-name">短信数量</div>
      <div class="line-value">
        {{ followDetail.sms_limit_size }}
        <Button
          size="small"
          class="expiretime-btn"
          v-if="user.isMain == 1 && user.sysrole == 1"
          @click="recharge(['短信充值', 'sMessageModal'])"
        >
          充值
        </Button>
      </div>
    </div>
    <div class="line">
      <div class="line-name">已使用短信数量</div>
      <div class="line-value">{{ followDetail.useSMNum }} 条</div>
    </div>
    <div class="line">
      <div class="line-name">固定存储数量</div>
      <div class="line-value">{{ followDetail.storage_limit }} G</div>
    </div>
    <div class="line">
      <div class="line-name">动态存储数量</div>
      <div class="line-value">
        {{ followDetail.dynamic_storage_limit }} G
        <Button
          size="small"
          class="expiretime-btn"
          v-if="user.isMain == 1 && user.sysrole == 1"
          @click="recharge(['存储数量', 'storageModal'])"
        >
          充值
        </Button>
      </div>
    </div>
    <div class="line">
      <div class="line-name">已使用存储数量</div>
      <div class="line-value">{{ followDetail.useStorageNum }} G</div>
    </div>
    <div class="line">
      <div class="line-name">区域</div>
      <div class="line-value">
        {{ followDetail.area }}
        <Button size="small" class="expiretime-btn" @click="district">
          修改
        </Button>
      </div>
    </div>
    <div class="line">
      <div class="line-name">所属服务商</div>
      <div class="line-value">
        {{ followDetail.service_provider_name }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">客户标签</div>
      <div class="line-value">
        {{ followDetail.label || '-' }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">已分配角色人数</div>
      <div class="line-value">
        {{ followDetail.userNum }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">已组织架构人数</div>
      <div class="line-value">
        {{ followDetail.useStructureNum }}
      </div>
    </div>
    <div class="line">
      <div class="line-name">是否个人版</div>
      <div class="line-value">
        {{ followDetail.is_personal === 1 ? '是' : '否' }}
      </div>
    </div>
    <div v-if="followDetail.is_personal === 1">
      <div class="line">
        <div class="line-name">主企业</div>
        <div
          v-if="followDetail.mainEpId == null || followDetail.mainEpId == -1"
          class="line-value"
          style="color: #3ccba6"
        >
          {{ followDetail.mainEpName || '-' }}
        </div>
        <div
          v-else
          class="line-value"
          style="color: #3ccba6"
          @click="
            $router.push({
              name: routerpush,
              params: { orderId: followDetail.mainEpId },
            })
          "
        >
          {{ followDetail.mainEpName || '-' }}
        </div>
      </div>
      <div class="line">
        <div class="line-name">主企业corpId</div>
        <div class="line-value">
          {{ followDetail.mainCorpId || '-' }}
        </div>
      </div>
    </div>

    <!-- 到期弹框 -->
    <Modal
      v-model="followUpRecListModal"
      width="600"
      title="编辑到期时间"
      :mask-closable="false"
      @on-ok="followUpRecList()"
    >
      <Form
        ref="followUpRecListForm"
        :model="followUpRecListForm"
        :rules="ruleValidate"
        :label-width="120"
        label-position="left"
      >
        <FormItem label="到期时间">
          <SmyDatePicker
            transfer
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="请选择提醒时间"
            style="width: 100%"
            :value="followUpRecListForm.data"
            @input="followUpRecListForm.data = $event"
          />
        </FormItem>
        <FormItem label="原因" prop="content" label-for="content">
          <Input
            placeholder="请输入延长的原因"
            element-id="content"
            v-model="followUpRecListForm.content"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="followUpRecListModal = false">取消</Button>
        <Button type="primary" @click="followUpRecList">确认</Button>
      </div>
    </Modal>
    <!-- 修改区域 -->
    <Modal
      width="600"
      title="编辑区域地址"
      :mask-closable="false"
      v-model="showAddModal"
      @on-ok="submit"
    >
      <Form ref="editListForm" label-position="right" :label-width="100">
        <FormItem label="地址">
          <AddressSelect
            placeholder="请选择区域地址"
            :value="address_city"
            @on-change="(id, name) => city_bb(id, name)"
            :level="2"
          />
        </FormItem>
        <!-- @on-change="(e) => {searchForm.prov_id = e[0],searchForm.city_id = e[1]}" -->
      </Form>
      <div slot="footer">
        <Button type="text" @click="showAddModal = false">取消</Button>
        <Button type="primary" @click="submit">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SmyDatePicker from '@/components/SmyDatePicker'
import AddressSelect from '@/components/AddressCB'

export default {
  components: {
    SmyDatePicker,
    AddressSelect,
  },
  props: {
    followDetail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('user', ['user']),
    address_city() {
      return [this.searchForm.prov_id, this.searchForm.city_id]
    },
    dateDisabledOptions() {
      return {
        disabledDate: (date) => {
          return (
            (date && date.valueOf() - 1296000000) > this.times ||
            (date && date.valueOf()) < this.times
          )
        },
      }
    },
    versions_name() {
      if (
        (this.followDetail.fk_t_charge_package_id === null ||
          this.followDetail.fk_t_charge_package_id === -1) &&
        this.followDetail.is_charge_user === 0
      ) {
        return 0
      } else if (
        this.followDetail.fk_t_charge_package_id !== null &&
        this.followDetail.is_charge_user !== 0 &&
        this.followDetail.is_charge_user !== 3
      ) {
        return 1
      } else if (
        (this.followDetail.fk_t_charge_package_id === null ||
          this.followDetail.fk_t_charge_package_id === -1) &&
        this.followDetail.is_charge_user !== 0 &&
        this.followDetail.is_charge_user !== 3
      ) {
        return 2
      } else if (this.followDetail.is_charge_user === 3) {
        return 3
      }
    },
    routerpush() {
      if (this.$route.name === 'AnalyzeList_FollowDetail_two') {
        return 'AnalyzeList_FollowDetail'
      } else {
        return 'AnalyzeList_FollowDetail_two'
      }
    },
  },
  methods: {
    // 充值
    recharge(e) {
      this.$emit('recharge', e)
    },
    city_bb($event, name) {
      if (name.length === 2) {
        this.prov_name = name[0].label
        this.city_name = name[1].label
        this.prov_id = $event[0]
        this.city_id = $event[1]
      } else {
        this.prov_id = $event[0]
        this.prov_name = name[0].label
      }
    },
    expiretime() {
      this.followUpRecListModal = true
    },
    district() {
      this.showAddModal = true
    },
    followUpRecList() {
      // let timenum = '1296000000'
      if (this.followUpRecListForm.content === '') {
        return this.$Message.error('延长的原因不能为空')
      }
      // if (this.times !== '') {
      //   if (Date.parse(this.followUpRecListForm.data) - this.times > timenum) {
      //     return this.$Message.error('延长期限15天以内')
      //   }
      // }
      // if (this.followUpRecListForm.data === '') {
      //   return this.$Message.error('延长的原因不能为空')
      // }
      let data = {
        id: this.followDetail.id,
        reason: this.followUpRecListForm.content,
        delayTime: this.followUpRecListForm.data,
      }
      this.$http.post('/enterprise/mgr/updateExpiration', data).then((res) => {
        if (res.success) {
          let msg = '编辑成功'
          this.$Message.success(msg)
          this.$emit('callback')
          this.followUpRecListModal = false
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    submit() {
      this.$http
        .post('/enterprise/mgr/updateAddress', {
          prov_id: this.prov_id,
          city_id: this.city_id,
          prov_name: this.prov_name,
          city_name: this.city_name,
          epId: this.followDetail.id,
        })
        .then((res) => {
          if (res.success) {
            let msg = '编辑成功'
            this.$Message.success(msg)
            this.$emit('callback')
            this.showAddModal = false
          } else {
            this.$Message.error(res.message)
          }
        })
    },
  },
  data() {
    return {
      orderCont: '2',
      followUpRecListModal: false,
      followUpRecListForm: {
        content: '',
        data: '',
      },
      ruleValidate: {
        content: [
          { required: true, message: '延长的原因不能为空', trigger: 'blur' },
        ],
      },
      // 日期配置 （无法选择今日之前的日期）
      // dateDisabledOptions: {
      //   disabledDate(date) {
      //     return date && date.valueOf() > Date.now() + 1296000000
      //   }
      // },
      showAddModal: false,
      searchForm: {},
      times: '',
      prov_name: '',
      city_name: '',
      prov_id: '',
      city_id: '',
      versions: ['免费版', '付费版', '试用版', '免费规格版'],
    }
  },
  watch: {
    followDetail(v) {
      this.followUpRecListForm.data = v.service_expire_time
      this.times = Date.parse(this.followDetail.service_expire_time)
    },
  },
}
</script>

<style lang="less" scoped>
.block {
  border-top: 1px #dddee1 dashed;
  padding-bottom: 11px;

  .line {
    display: flex;
    padding-top: 10px;
    line-height: 20px;

    .line-name {
      width: 100px;
      font-size: 12px;
      color: #405060;
    }

    .line-value {
      width: 188px;
      margin-left: 10px;
      font-size: 12px;
      color: #80848f;
      overflow: hidden;
    }

    .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .expiretime-btn {
    // margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/cusFollowDetail/FollowDetailLeft.vue